import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTerminal = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.90625 6.5625L8.53125 8.53125L5.90625 10.5M9.84375 10.5H12.4688M4.59375 17.7188H16.4062C17.4936 17.7188 18.375 16.8373 18.375 15.75V5.25C18.375 4.16269 17.4936 3.28125 16.4062 3.28125H4.59375C3.50644 3.28125 2.625 4.16269 2.625 5.25V15.75C2.625 16.8373 3.50644 17.7188 4.59375 17.7188Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTerminal;
